// src/utils/forms/productFormHelpers.js

import { PRODUCT_TYPES } from "../../components/products/ProductForm/helpers/formConstants";

/**
 * ✅ Get product type from data
 */
export const getProductTypeInfo = (productType) => {
    const productTypeName = productType?.name?.en || productType?.name || "";
    const isTransfer = productTypeName.toLowerCase().includes(PRODUCT_TYPES.TRANSFER);
    const isTour = productTypeName.toLowerCase().includes(PRODUCT_TYPES.TOUR);

    return { productTypeName, isTransfer, isTour };
};

/**
 * ✅ Parse multi-language field
 */
export const parseMultiLang = (field) => {
    if (!field) return { ar: "", en: "" };
    if (typeof field === "string") return { ar: field, en: field };
    return {
        ar: field.ar || "",
        en: field.en || "",
    };
};

/**
 * ✅ Extract image URL
 */
export const extractImageUrl = (image) => {
    if (!image) return "";
    if (typeof image === "string") return image;
    return image.file_name || image.url || image.preview || "";
};

/**
 * ✅ Process images array
 */
export const processImages = (images) => {
    if (!images || !Array.isArray(images)) return [];
    return images.map((img) => ({
        id: img.id,
        file_name: img.file_name || img.url || img.preview || "",
        url: img.url || img.preview || "",
        thumbnail: img.thumbnail || "",
        preview: img.preview || img.url || "",
    }));
};
